import gql from 'graphql-tag';

const query = gql`
  mutation calculateInsulinDose($request: InsulinDoseCalculateInputType!) {
    diabetes {
      calculateInsulinDose(request: $request) {
        ... on InsulinDoseCalculation {
          measurement {
            id
            value {
              value
              unit
            }
            valueLabel
            date
            mealType
          }
          insulinDose
          __typename
        }

        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }

        ... on Error {
          name
          description
        }
      }
    }
  }
`;

export default query;
